import {
  apolloRichTextSchema,
  contentfulRichTextSchema,
  documentSchema
} from '@ecomm/contentful-schemas'
import { type TypeOf, z } from '@simplisafe/ewok'

import {
  apolloButtonSchema,
  apolloIconAndTextSchema
} from '@ecomm/shared-components'
import { possibleEmbeddedSchema } from './utils'

export const themes = {
  grayWithOrange: 'Gray with Orange',
  navyWithWhiteText: 'Navy with White Text',
  navyWithOrange: 'Navy with Orange',
  orangeWithNavyText: 'Orange with Navy Text',
  lightGrayWithNavyText: 'Light Gray with Navy Text'
}

export const coloredSectionSchema = z.object({
  content: z
    .object({
      text: z.object({
        raw: z.string(),
        references: possibleEmbeddedSchema.array().optional()
      })
    })
    .array()
    .default([]),
  disclaimer: contentfulRichTextSchema.nullish(),
  headline: z.string().nullish(),
  theme: z
    .enum([
      'Navy with White Text',
      'Gray with Orange',
      'Navy with Orange',
      'Orange with Navy Text',
      'Light Gray with Navy Text'
    ])
    .optional(),
  __typename: z.literal('ContentfulColoredSection')
})

export const gastbyColoredSectionSchema = z.object({
  __typename: z.literal('ContentfulColoredSection'),
  contentful_id: z.string()
})

const embeddedEntrySchema = z
  .object({
    entries: z.object({
      block: z.array(z.union([apolloIconAndTextSchema, apolloButtonSchema]))
    })
  })
  .default({ entries: { block: [] } })

const apolloContentCollectionItemSchema = z.object({
  text: z.object({
    json: documentSchema,
    links: embeddedEntrySchema.optional()
  })
})

export const apolloColoredSectionSchema = z.object({
  contentCollection: z.object({
    items: z.array(apolloContentCollectionItemSchema).default([])
  }),
  disclaimer: apolloRichTextSchema.nullish(),
  headline: z.string().nullish(),
  theme: z
    .enum([
      'Navy with White Text',
      'Gray with Orange',
      'Navy with Orange',
      'Orange with Navy Text',
      'Light Gray with Navy Text'
    ])
    .optional(),
  __typename: z.literal('ColoredSection')
})

export type ColoredSectionSchema = TypeOf<typeof coloredSectionSchema>
export type GatsbyColoredSectionSchema = TypeOf<
  typeof gastbyColoredSectionSchema
>
export type ApolloColoredSectionSchema = TypeOf<
  typeof apolloColoredSectionSchema
>
